<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Product"></app-page-title>
        <form [formGroup]="productForm" (ngSubmit)="addProduct()" (keydown.enter)="useEnterKey ? $event.preventDefault() : addProduct()">

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="productcode" class="form-label">Code <span
                                                class="mandatory">*</span></label>
                                        <input type="text" maxlength="5" class="form-control form-control-sm"
                                            id="productcode" formControlName="txtCode"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || productForm.get('txtCode').touched) && productForm.get('txtCode').errors}"  >
                                        <div *ngIf="(isFormSubmitted || productForm.get('txtCode').touched) && productForm.get('txtCode').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="productForm.get('txtCode').errors.required">Code is
                                                required</span>
                                            <span *ngIf="productForm.get('txtCode').errors.maxlength">Code must be 5
                                                characters.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="productname" class="form-label">Name <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="productname"
                                            formControlName="txtName" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || productForm.get('txtName').touched) && productForm.get('txtName').errors}" >
                                        <div *ngIf="(isFormSubmitted || productForm.get('txtName').touched) && productForm.get('txtName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="productForm.get('txtName').errors.required">Name is
                                                required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="productType" class="form-label">Product Type <span
                                                class="mandatory">*</span></label>
                                        <ng-select formControlName="ddlProductType" [items]="productTypeList"
                                            id="productType" [appendTo]="'body'" [openOnEnter]="false" [clearable]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            placeholder="Select"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || productForm.get('ddlProductType').touched) && productForm.get('ddlProductType').errors}" >
                                        </ng-select>

                                        <div *ngIf="(isFormSubmitted || productForm.get('ddlProductType').touched) && productForm.get('ddlProductType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="productForm.get('ddlProductType').errors.required">Product Type
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="applicablecharge" class="form-label">Applicable Charge</label>
                                        <ng-select formControlName="ddlApplicableCharge" [items]="applicableChargeList"
                                            id="applicablecharge" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            placeholder="Select" >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="type" class="form-label">Shipment Type</label>
                                        <div>
                                            <div role="group" aria-label="radio button group" class="btn-group">
                                                <input type="radio" id="btnradio4" autocomplete="off"
                                                    formControlName="shipmentType" value="DOX" class="btn-check" >
                                                <label for="btnradio4"
                                                    class="btn btn-outline-secondary btn-sm">DOX</label>
                                                <input type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                                                    formControlName="shipmentType" value="NDOX" >
                                                <label for="btnradio5"
                                                    class="btn btn-outline-secondary btn-sm">NDOX</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
<!--                                <div class="col-md-3" formGroupName="volumetricDivisor">-->
<!--                                    <div class="mb-2">-->
<!--                                        <label for="weight" class="form-label">Volumetric Divisor</label>-->
<!--                                        <div class="input-group mb-2">-->
<!--                                            <span class="input-group-text group-label-sm">Centimeter</span>-->
<!--                                            <ng-select formControlName="ddlCentimeter" [items]="centimeterList"-->
<!--                                                id="centimeter" [appendTo]="'body'" [openOnEnter]="false" placeholder="Select"-->
<!--                                                [clearable]="false" ></ng-select>-->

<!--                                            <span class="input-group-text group-label-sm">Inches</span>-->
<!--                                            <ng-select formControlName="ddlInches" [items]="inchesList" id="inches"-->
<!--                                                [appendTo]="'body'" [openOnEnter]="false" placeholder="Select"-->
<!--                                                [clearable]="false" ></ng-select>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="">
                                        <label for="status" class="form-label">Status</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="status" [checked]="productForm.get('status').value" >
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm" >Add</button>
                        <a routerLink="/setup/products"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>